{
  "results": {
    "title": "Results",
    "description": "Every calculation creates an immutable result run; previous calculations remain available for audit.",
    "calculate": "Calculate results",
    "calculateWarning": "This only includes submissions with at least 2 judges' locked scores and no active conflict of interest. Submissions that don't qualify will be listed as \"Missing Valid Scores\" below.",
    "calculateConfirm": "Confirm calculation",
    "calculateSuccess": "Results calculated.",
    "calculateFailed": "Could not calculate results.",
    "lock": "Lock",
    "lockWarning": "After locking you can still adjust award tiers (with a reason) until you publish; a published run is final and must be recalculated to change. This does not affect other result runs, and the run itself is never deleted.",
    "lockConfirm": "Confirm lock",
    "publish": "Publish",
    "transitionSuccess": "Result status updated.",
    "transitionFailed": "Could not update the result status.",
    "roundsTablist": "Rounds",
    "categoriesTablist": "Categories",
    "allCategories": "All categories",
    "metadata": {
      "runId": "Result Run ID",
      "round": "Round",
      "category": "Category",
      "calculatedAt": "Calculated at",
      "calculatedBy": "Calculated by",
      "included": "Included scores",
      "missing": "Missing valid scores",
      "tie": "Tie",
      "tieValue": "Two or more submissions share the same score",
      "lockedBy": "Locked by",
      "publishedBy": "Published by",
      "disqualified": "Disqualified (not counted)"
    },
    "awardTiers": {
      "none": "No override",
      "first": "First place",
      "second": "Second place",
      "third": "Third place",
      "honorable": "Honorable mention",
      "vacant": "Vacant"
    },
    "reviewComments": {
      "expandAll": "Expand all review comments",
      "collapseAll": "Collapse all review comments",
      "toggle": "View judges’ review comments",
      "empty": "No submitted scores yet.",
      "blank": "(no review comment)"
    },
    "override": {
      "reasonPlaceholder": "Reason for this override (required)",
      "apply": "Apply"
    },
    "advancement": {
      "title": "Decide who advances",
      "description": "Pick which teams move on to {{round}}, based on the result run below.",
      "noRun": "Calculate this round's results first.",
      "empty": "No results to advance yet.",
      "topN": "Top N",
      "selectTopN": "Select top N",
      "selectRow": "Select {{team}} to advance",
      "advanced": "advanced",
      "confirm": "Advance {{count}} team(s)",
      "confirming": "The following {{count}} team(s) will be marked as advancing to {{round}}. This will be visible to participants, and the system will email the members of these teams (teachers excluded). Please confirm the list is correct:",
      "confirmSubmit": "Confirm and submit",
      "confirmed": "{{count}} team(s) advanced.",
      "failed": "Could not advance the selected teams."
    },
    "disqualifiedNotice": "These teams are disqualified and not counted in this result: {{teams}}. Please confirm before publishing.",
    "manualBreakdown": "judges {{judge}}, manual {{manual}}"
  }
}
